<kendo-drawer-container>
  <kendo-drawer #drawer [mode]="expandMode" (expandedChange)="onExpandChange($event)" [expanded]="drawerState()">
    <ng-template kendoDrawerTemplate>
      @if (!inEulaPage()) {
        <nav class="mb-2 flex flex-col">
          <a
            *csUserHasAnyScope="[PermissionScope.READ_SHIPMENTS]"
            routerLink="/shipments"
            (click)="drawer.toggle()"
            routerLinkActive="active"
            class="w-full border-l-4 border-l-transparent p-4"
            >Shipments</a
          >
          <a
            *csUserHasAnyScope="[
              PermissionScope.READ_DEVICES,
              PermissionScope.READ_LABELS,
              PermissionScope.READ_SOURCE_GROUPS,
            ]"
            routerLink="/data-sources"
            (click)="drawer.toggle()"
            routerLinkActive="active"
            class="w-full border-l-4 border-l-transparent p-4"
            >Data Sources</a
          >
          <a
            *csUserHasAnyScope="[PermissionScope.READ_FACILITIES]"
            routerLink="/facilities"
            (click)="drawer.toggle()"
            routerLinkActive="active"
            class="w-full border-l-4 border-l-transparent p-4"
            >Facilities</a
          >
          @if (utils.isAdminTabEnabled()) {
            <div *csUserHasAnyScope="[PermissionScope.READ_ADMIN_PANEL]">
              <cs-toggle-menu [menuProps]="subItemsAdmin" (closeDrawerEvent)="drawer.toggle()"></cs-toggle-menu>
            </div>
          }
        </nav>
        <cs-user-menu (logout)="handleLogout()" [user]="user()" (closeEvent)="drawer.toggle()"></cs-user-menu>
      }
    </ng-template>
  </kendo-drawer>

  <kendo-drawer-content class="min-w-[340px]">
    @if (!inEulaPage()) {
      @if (enableMaintenanceMode) {
        <cs-maintenance-mode></cs-maintenance-mode>
      }
      <cs-navbar class="absolute z-30 w-full" [user]="user()"></cs-navbar>
    }
    <div kendoRippleContainer>
      <router-outlet></router-outlet>
    </div>
  </kendo-drawer-content>
</kendo-drawer-container>
<cs-deactivate-dialog></cs-deactivate-dialog>
